<div class="opentime-selector-container theme-interface d-flex flex-wrap justify-content-center align-items-center">
    <div class="selection-container p-4 position-absolute">
        <div class="header-container d-flex flex-wrap">
            <div class="w-100">
                <div class="text-center justify-content-center theme-color-header font-size-title font-weight-bold pt-3"
                    (click)="onCheckOutsideClose($event)">
                    <div *ngIf="isClosedForOrdering">
                        <span class="theme-color-subtitle-2">{{'public.store.currently.closed' | translate}}</span><br>
                        <span class="theme-color-subtitle-2">{{'public.store.dashboard.placeOrderInOpeningTimes' |
                            translate}}</span>
                    </div>
                    <span
                        class="float-right position-absolute closebutton text-decoration-underline font-weight-bold theme-color-header">
                        {{'public.global.close' | translate}}<i class="fas fa-times pl-2 theme-color-header"></i>
                    </span>
                </div>
            </div>
        </div>
        <mat-tab-group #tabGroup [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="onTabChange($event)"
            animationDuration="0ms">
            <mat-tab label="{{'public.store.catalog.aboutUs' | translate}}" class="theme-light-cat-name-bg-light-grey">
                <div class="row mt-3 w-100 font-size-primary" *ngIf="selectedStore?.phoneNumber?.length > 8">
                    <div class="col-md-12">
                        <i class="theme-color-header text-primary fas fa-phone mr-2"></i>
                        <span>{{selectedStore?.phoneNumber}}</span>
                    </div>
                </div>
                <div class="row mt-3 w-100 font-size-primary" *ngIf="selectedStore?.settings?.STORE_WEBSITE_URL">
                    <div class="col-md-12">
                        <i class="theme-color-header fas fa-solid fa-globe mr-2"></i>
                        <a href="{{selectedStore?.settings?.STORE_WEBSITE_URL}}"
                            target="_blank">{{selectedStore?.settings?.STORE_WEBSITE_URL}}</a>
                    </div>
                </div>

                <div class="row mt-3 w-100 font-size-primary" *ngIf="selectedStore?.settings?.DISPLAY_ADDRESS">
                    <div class="col-md-12">
                        <span class="mr-2 locationMarker"><i
                                class="theme-color-header text-primary fas fa-solid fa-location-dot"></i></span>
                        <span>{{selectedStore?.address.addressLine1}}</span>
                        <span class="ml-1" *ngIf="selectedStore?.address.addressLine2"
                            class="ml-1">{{selectedStore?.address.addressLine2}}</span>
                        <span class="ml-1">{{selectedStore?.address.city}},
                            {{(selectedStore$ |
                            async)?.address.region}}</span>
                        <span class="ml-1">{{selectedStore?.address.postCode}}</span>
                        <span class="ml-1">{{selectedStore?.address.country.name}}</span>
                    </div>
                </div>
                <div class="row mt-3 w-100 font-size-primary"
                    [ngClass]="{'d-none': !selectedStore?.settings?.DISPLAY_ADDRESS}">
                    <div class="col-md-12">
                        <div class="col-of">
                            <div #mapWrapper id="map"></div>
                        </div>
                    </div>
                </div>

                <div class="form-group row mt-3 mb-4 d-flex align-items-center w-100 font-size-primary"
                    *ngIf="isSocialMediaHandlePresent()">
                    <label class="col-xl-4 col-lg-4 col-md-4 form-header">{{
                        'public.thankyou.followSocialMedia' |
                        translate }}</label>
                    <div class="col-md-5">
                        <div class="d-flex justify-content-start">
                            <div class="mr-3" *ngIf="selectedStore?.settings?.FACEBOOK_URL">
                                <a href="{{selectedStore?.settings.FACEBOOK_URL}}" target="_blank"><img
                                        src="assets/img/marketing/facebook.svg" alt="" height="35px"></a>
                            </div>
                            <div class="mr-3" *ngIf="selectedStore?.settings?.INSTAGRAM_URL">
                                <a href="{{selectedStore?.settings.INSTAGRAM_URL}}" target="_blank"><img
                                        src="assets/img/marketing/instagram.svg" alt="" height="35px"></a>
                            </div>
                            <div class="mr-3" *ngIf="selectedStore?.settings?.TIKTOK_URL">
                                <a href="{{selectedStore?.settings.TIKTOK_URL}}" target="_blank"><img
                                        src="assets/img/marketing/tiktok.svg" alt="" height="35px"></a>
                            </div>
                            <div class="mr-3" *ngIf="selectedStore?.settings?.TWITTERX_URL">
                                <a href="{{selectedStore?.settings.TWITTERX_URL}}" target="_blank"><img
                                        src="assets/img/marketing/twitter_x.svg" alt="" height="35px"></a>
                            </div>
                            <div *ngIf="selectedStore?.settings?.CARDITIO_URL">
                                <a href="{{selectedStore?.settings.CARDITIO_URL}}" target="_blank"><img
                                        src="assets/img/marketing/Cardit.png" alt="" height="35px"></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row w-100 mb-4 d-flex align-items-center font-size-primary"
                    *ngIf="isReviewMediaHandlePresent()">
                    <label class="col-xl-4 col-lg-4 col-md-4 form-header">{{
                        'public.thankyou.leaveUsReview' | translate
                        }}</label>
                    <div class="col-md-5">
                        <div class="d-flex justify-content-start">
                            <div class="mr-3" *ngIf="selectedStore?.settings?.GOOGLE_BUSINESS_PAGE_URL">
                                <a href="{{selectedStore.settings.GOOGLE_BUSINESS_PAGE_URL}}" target="_blank"><img
                                        src="assets/img/marketing/google.svg" alt="" height="35px"></a>
                            </div>
                            <div class="mr-3" *ngIf="selectedStore?.settings?.TRIP_ADVISOR_URL">
                                <a href="{{selectedStore.settings.TRIP_ADVISOR_URL}}" target="_blank"><img
                                        src="assets/img/marketing/trip_advisor.svg" alt="" height="35px"></a>
                            </div>
                        </div>
                    </div>
                </div>

            </mat-tab>
            <mat-tab label="{{'public.global.opentimelist' | translate}}" *ngIf="openTimeSchedule"
                class="theme-light-cat-name-bg-light-grey">
                <div class="opentime-container container py-2 font-size-primary">
                    <div *ngFor="let day of openTimeSchedule">
                        <div *ngIf="day.items.length > 0" class="row font-size-primary py-2">
                            <div class="col-day font-size-primary">{{day.title | translate}}</div>
                            <div class="col-time row">
                                <div class="col-sm-6 text-center time-item font-size-primary"
                                    *ngFor="let item of day.items">
                                    <ng-container *ngIf="!item.time24h">
                                        {{item.startTime}} - {{item.endTime}}
                                    </ng-container>
                                    <ng-container *ngIf="item.time24h">
                                        {{'public.global.time24h' | translate}}
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="day.items.length == 0" class="row font-size-primary py-2">
                            <div class="col-day font-size-primary">{{day.title | translate}}</div>
                            <div class="col-time row">
                                <div class="col-sm-6 text-center time-item font-size-primary">
                                    {{'public.global.closed' | translate}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>